import { InjectionToken } from '@angular/core';

export interface ApiGatewayConfig {
    apiKey: string;
    apiPortalBaseUrl: string;
}

export const API_GATEWAY_CONFIG = new InjectionToken<ApiGatewayConfig>('API_PORTAL:CONFIG');
export const API_GATEWAY_BASE_URL_PLACEHOLDER = '/sew-api-gateway-dmz';
